module.exports = __webpack_public_path__ + "static/media/notifications.84e93cc5.png";